<template>
  <adaptive-popper @show="showCalendar" :autobox="autobox" @hide="close" height="400" noscrollbar :title="title">
    <template #element>
      <slot></slot>
    </template>
    <template #content="{ mobile }">
      <slot name="content"/>
      <div class="k-calendar" ref="calendar" :class="{ autobox }">
        <div class="k-calendar__switcher mb-2" v-if="rangeSelect">
          <span :class="{ active: overload === 'day' }" @click="overload = 'day'">Выбрать день</span>
          <span :class="{ active: overload === 'range' }" @click="overload = 'range'">Выбрать период</span>
        </div>
        <div class="k-calendar__header" :class="{ mobile }">
          <div class="k-calendar-row">
            <popper
              v-if="!mobile"
              ref="monthPopper"
              trigger="clickToToggle"
              :options="{
                placement: 'bottom',
              }"
            >
              <div class="popper k-modal-popper">
                <div class="k-calendar-picker">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <span>
                      <svg @click="setPrevYear" class="k-calendar-arrow mr-3" width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.77624 14.6625L2.01381 8L8.77624 1.33754C9.07459 1.0347 9.07459 0.52997 8.77624 0.227131C8.4779 -0.0757083 7.98066 -0.0757084 7.58287 0.227131L0.223756 7.39432C-0.074587 7.69716 -0.0745871 8.20189 0.223755 8.50473L7.48342 15.7729C7.78177 16.0757 8.279 16.0757 8.67679 15.7729C9.07458 15.47 9.07458 14.9653 8.77624 14.6625Z" fill="#808080"/>
                      </svg>
                    </span>
                    <span class="k-calendar-picker__item px-2">{{ currentDate.year }}</span>
                    <span>
                      <svg @click="setNextYear" class="k-calendar-arrow" width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.223758 1.33754L6.98619 8L0.223757 14.6625C-0.0745858 14.9653 -0.0745859 15.47 0.223757 15.7729C0.522099 16.0757 1.01934 16.0757 1.41713 15.7729L8.77624 8.60568C9.07459 8.30284 9.07459 7.79811 8.77624 7.49527L1.51658 0.227127C1.21823 -0.075711 0.720996 -0.075711 0.323206 0.227127C-0.0745836 0.529967 -0.0745846 1.0347 0.223758 1.33754Z" fill="#808080"/>
                      </svg>
                    </span>
                  </div>
                  <div class="d-flex flex-wrap">
                    <div @click="setMonth(index)" v-for="(month, index) in getYearMonthes()" :key="index" class="k-calendar-picker__item col-6">{{ month }}</div>
                  </div>
                </div>
              </div>

              <div slot="reference">
                <p class="k-calendar-month-date mr-1">{{ getCurrentMonthName }}</p>
              </div>
            </popper>

            <popper
              ref="yearPopper"
              trigger="clickToToggle"
              :options="{
                placement: 'bottom',
              }"
            >
              <div class="popper k-modal-popper">
                <div class="k-calendar-picker">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <span>
                      <svg @click="currentYearOffset !== getYears.length - 1 && currentYearOffset++" class="k-calendar-arrow mr-3" width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.77624 14.6625L2.01381 8L8.77624 1.33754C9.07459 1.0347 9.07459 0.52997 8.77624 0.227131C8.4779 -0.0757083 7.98066 -0.0757084 7.58287 0.227131L0.223756 7.39432C-0.074587 7.69716 -0.0745871 8.20189 0.223755 8.50473L7.48342 15.7729C7.78177 16.0757 8.279 16.0757 8.67679 15.7729C9.07458 15.47 9.07458 14.9653 8.77624 14.6625Z" fill="#808080"/>
                      </svg>
                    </span>
                    <span class="k-calendar-picker__item px-2">{{ currentDate.year }}</span>
                    <span>
                      <svg @click="currentYearOffset > 0 && currentYearOffset--" class="k-calendar-arrow" width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.223758 1.33754L6.98619 8L0.223757 14.6625C-0.0745858 14.9653 -0.0745859 15.47 0.223757 15.7729C0.522099 16.0757 1.01934 16.0757 1.41713 15.7729L8.77624 8.60568C9.07459 8.30284 9.07459 7.79811 8.77624 7.49527L1.51658 0.227127C1.21823 -0.075711 0.720996 -0.075711 0.323206 0.227127C-0.0745836 0.529967 -0.0745846 1.0347 0.223758 1.33754Z" fill="#808080"/>
                      </svg>
                    </span>
                  </div>
                  <div class="d-flex flex-wrap">
                    <div @click="setYear(year)" v-for="(year, index) in getYearsOffset" :key="index" class="k-calendar-picker__item col-6">{{ year }}</div>
                  </div>
                </div>
              </div>

              <div slot="reference">
                <p class="mr-2">{{ currentDate.year }}</p>
              </div>
            </popper>
            <svg v-if="!mobile" @click="setPrevMonth" class="k-calendar-arrow mr-3" width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.77624 14.6625L2.01381 8L8.77624 1.33754C9.07459 1.0347 9.07459 0.52997 8.77624 0.227131C8.4779 -0.0757083 7.98066 -0.0757084 7.58287 0.227131L0.223756 7.39432C-0.074587 7.69716 -0.0745871 8.20189 0.223755 8.50473L7.48342 15.7729C7.78177 16.0757 8.279 16.0757 8.67679 15.7729C9.07458 15.47 9.07458 14.9653 8.77624 14.6625Z" fill="#808080"/>
            </svg>
            <svg v-if="!mobile" @click="setNextMonth" class="k-calendar-arrow" width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.223758 1.33754L6.98619 8L0.223757 14.6625C-0.0745858 14.9653 -0.0745859 15.47 0.223757 15.7729C0.522099 16.0757 1.01934 16.0757 1.41713 15.7729L8.77624 8.60568C9.07459 8.30284 9.07459 7.79811 8.77624 7.49527L1.51658 0.227127C1.21823 -0.075711 0.720996 -0.075711 0.323206 0.227127C-0.0745836 0.529967 -0.0745846 1.0347 0.223758 1.33754Z" fill="#808080"/>
            </svg>
          </div>
          <p class="k-calendar__button-today" v-if="!mobile && !weekSelect && !rangeSelect" @click="setToday">
            Сегодня
          </p>
        </div>
        <div class="mb-3" v-if="mobile">
          <swiper :options="swiperOption" @slideChange="monthSelect" ref="swiper">
            <swiper-slide
              class="text-center k-calendar-month-item"
              ref="monthItem"
              v-for="(month, index) in months"
              :key="index"
            >{{ month.title }}</swiper-slide>
          </swiper>
        </div>

        <div class="k-calendar__body">
          <div class="k-calendar-days k-calendar-row">
            <span class="k-calendar-day-wrapper" v-for="(day, index) in days" :key="index">
              <span class="k-calendar-day" >{{ day }}</span>
            </span>
          </div>
          <div class="k-calendar-divider mt-2 mb-3"></div>
          <div
            class="k-calendar-days k-calendar-row k-calendar-week"
            :class="{ disabled: !availableAll && !isAvailableWeek(week) && !test }"
            v-for="(week, weekIndex) in calendar"
            :key="weekIndex"
            @click="selectWeek(weekIndex)"
          >
            <div class="k-calendar-row w-100 justify-content-between">
              <span
                v-for="(day, index) in week"
                :key="index"
                class="k-calendar-day-wrapper"
                :class="{
                  selected: checkSelectedDay(day.date).current,
                  first: checkSelectedDay(day.date).first,
                  last: checkSelectedDay(day.date).last,
                }"
              >
                <span
                  v-if="!isSpecialData"
                  class="k-calendar-day text-right"
                  :class="{
                    test: test,
                    inactive: test ? checkNotInTrialWeek(day.date) : day.isEmpty,
                    current: day.current,
                    active: !isSpecialData && checkActiveDay(day.date),
                    selected: checkSelectedDay(day.date).current,
                    first: checkSelectedDay(day.date).first,
                    last: checkSelectedDay(day.date).last,
                    special: checkSpecialDay(day.date),
                    disabled: !isAvailableDay(day.date)
                  }"
                  @click="evt => clickDay(day, evt)"
                >{{ day.number }}</span>
                <adaptive-popper v-else autobox noscrollbar :disabled="!isAvailableDay(day.date)">
                  <template #element>
                    <span
                      class="k-calendar-day text-right"
                      :class="{
                        inactive: day.isEmpty,
                        current: day.current,
                        active: !isSpecialData && checkActiveDay(day.date),
                        selected: checkSelectedDay(day.date).current,
                        first: checkSelectedDay(day.date).first,
                        last: checkSelectedDay(day.date).last,
                        special: checkSpecialDay(day.date),
                        disabled: !isAvailableDay(day.date)
                      }"
                      @click="evt => clickDay(day, evt)"
                    >{{ day.number }}</span>
                  </template>
                  <template #content>
                    <switcher :busy="specialBusy" class="k-sprecial-filter" :items="getDishTypeSwitch" :activeItem="getSelectedMealData(day.date).meal_type" color="orange" @update:activeItem="value => makeDateRecipe(specialData, getSelectedMealData(day.date), value, day.date)"/>
                  </template>
                </adaptive-popper>
              </span>
            </div>
          </div>
          <p v-if="specialError" role="alert" class="error-message">{{ specialError }}</p>
          <p class="k-calendar-description">{{ description }}</p>
        </div>
      </div>
    </template>
  </adaptive-popper>
</template>

<script>
import { setDateAndMealType } from "../api/SpecialApi";

import 'swiper/css/swiper.css'
import AdaptivePopper from './TheAdaptivePropper';
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import dateFormat from '../utils/dateformat';
import Switcher from './TheSwitcher';
import { businessDate, isShoppingAssignmentActive } from '../utils/shopping-state';

// import { dayNicifier } from '../utils/helper';

export default {
  components: {
    swiper,
    swiperSlide,
    AdaptivePopper,
    Switcher,
  },
  props: {
    title: {
      type: String,
      default: 'Выберите дату',
    },
    menuId: String,
    specialData: {
      type: Object,
      default: () => ({})
    },
    currentSetDate: {
      default: null,
    },
    currentSetWeek: {
      default: () => ({
        from: new Date(),
        to: (new Date).setDate((new Date).getDate() + 6),
      }),
    },
    currentSetRange: {
      default: () => ({
        from: new Date(),
        to: (new Date).setDate((new Date).getDate() + 9),
      }),
    },
    position: {
      type: String,
      default: 'auto',
    },
    weekSelect: {
      type: Boolean,
      default: false,
    },
    rangeSelect: {
      type: Boolean,
      default: false,
    },
    availableAll: {
      type: Boolean,
      default: false,
    },
    description: {
      type: String,
      default: '',
    },
    autobox: Boolean,
    test: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    currentDate: {
      async handler() {
        this.calendar = this.generateCurrentCalendar();
        this.generateAvailableDays()
      },
      deep: true,
    },
    overload(value) {
      if (value === 'day') {
        this.$emit('date', this.selectedDate || this.currentSetDate)
      } else {
        this.$emit('range', { ...(this.selectedRange || this.currentSetRange) })
      }
      this.$emit('overload', value);
    }
  },
  data: () => ({
    currentYearOffset: 0,
    currentClassPosition: [],
    selectedDate: null,
    selectedWeek: null,
    selectedRange: null,
    currentDate: {
      year: null,
      month: null,
    },
    calendar: [],
    months: [
      { title: 'Январь', index: 0 },
      { title: 'Февраль', index: 1 },
      { title: 'Март', index: 2 },
      { title: 'Апрель', index: 3 },
      { title: 'Май', index: 4 },
      { title: 'Июнь', index: 5 },
      { title: 'Июль', index: 6 },
      { title: 'Август', index: 7 },
      { title: 'Сентябрь', index: 8 },
      { title: 'Октябрь', index: 9 },
      { title: 'Ноябрь', index: 10 },
      { title: 'Декабрь', index: 11 },
    ],
    days: ['Пн','Вт','Ср','Чт','Пт','Сб','Вс'],
    swiperOption: {
      slidesPerView: 3,
      spaceBetween: 80,
      centeredSlides: true,
      slideToClickedSlide: true,
    },
    shoppingToday: businessDate(),
    specialBusy: false,
    specialError: "",
  }),

  mounted() {
    this._shoppingClock = setInterval(() => { this.shoppingToday = businessDate(); }, 60000);
  },
  beforeDestroy() { clearInterval(this._shoppingClock); },

  computed: {
    overload: {
      get() { return this.$store.getters.getOverload },
      set(value) { this.$store.commit('setOverload', value) }
    },
    isRangeSelect() {
      return this.rangeSelect && this.overload === 'range';
    },
    getDishTypeSwitch() {
      return [
          { tab: 'breakfast', title: 'Завтрак' },
          { tab: 'lunch', title: 'Обед' },
          { tab: 'brunch', title: 'Перекус' },
          { tab: 'dinner', title: 'Ужин' },
        ]
    },
    isSpecialData() {
      return !!this.specialData.id;
    },
    getCurrentMonthName() {
      const current = this.months.find(el => el.index === this.currentDate.month);
      return current && current.title;
    },
    getYears() {
      const from = 1900;
      let to = from;

      const result = [];
      while (to <= (new Date).getFullYear()) {
        result.push((new Array(12).fill(to).map((el, index) => el + index)));
        to += 12;
      }

      return result
    },
    getYearsOffset() {

      return this.getYears[this.getYears.length - this.currentYearOffset - 1];
    },
  },
  methods: {
    checkNotInTrialWeek(day) {
      const startTrialTime = new Date(this.currentSetWeek.from).setHours(0,0,0,0)
      const endTrailTime = new Date(this.currentSetWeek.to).setHours(0,0,0,0)
      const dayTime = new Date(day).setHours(0,0,0,0)

      const isDayInTrial = dayTime >= startTrialTime && dayTime <= endTrailTime

      return !isDayInTrial
    },

    async unselectSpecialDay(recipe, evt) {
      evt.stopPropagation();

      await setDateAndMealType({
        date: null,
        meal_type: null,
        recipe_id: recipe.id,
        recipe_set_id: this.menuId,
      })

      recipe.set_meals = []
    },
    async makeDateRecipe(recipe, selected, mealType, selectedDate) {
      if (this.specialBusy) return;
      this.specialBusy = true;
      this.specialError = "";
      try {
        const { data } = await setDateAndMealType({
          date: dateFormat(selectedDate || recipe.date, 'yyyy-mm-dd'),
          recipe_id: recipe.id,
          meal_type: mealType,
          recipe_set_id: this.menuId,
          shopping_action: 'include',
        });
        if (!data || !data.success || !data.data || !data.data.set_meal) throw new Error('SaveNotConfirmed');
        this.addOrChangeSetMeal(recipe, data);
      } catch (error) {
        // Keep the last server-confirmed assignment; a lost response may have committed.
        // Retrying the selected date is idempotent on the API.
        this.specialError = "Не удалось подтвердить сохранение. Повторите выбор приёма пищи.";
      } finally {
        this.specialBusy = false;
      }
    },
    addOrChangeSetMeal(recipe, { data }) {
      const set_meal = data.set_meal;
      let current = recipe.set_meals.find(el => el.id === set_meal.id);

      if (current) {
        recipe.set_meals = recipe.set_meals.filter(el => el.id !== set_meal.id);
      }
      recipe.set_meals.push(set_meal);

      this.$forceUpdate();
    },
    getSelectedMealData(date) {
      const current = this.specialData.set_meals.find(el => dateFormat(el.date, 'yyyy-mm-dd') === dateFormat(date, 'yyyy-mm-dd'));
      return current || { meal_type: null };
    },
    generateAvailableDays() {
      if (this.calendar.length === 0) return []

      const currentWeek = this.calendar.find(week => week.some(day => day.current))
      if (!currentWeek) return [];

      const { date } = currentWeek[0];

      const res = [date, new Date(date).setDate(new Date(date).getDate() + 7)]
      return res
    },
    clickDay(day/*, evt */) {
      if (!this.isAvailableDay(day.date)) {
        return;
      }
      if (this.checkSpecialDay(day.date)) {
        // Dirty hack for preventing incorrect shopping items removal
        return;
        // this.unselectSpecialDay(this.specialData, evt)
      } else {
        this.selectDate(day, this.checkSelectedDay(day.date))
      }
    },
    isAvailableDay(day) {
      // return true;
      return dateFormat(day, 'yyyy-mm-dd') >= this.shoppingToday;
    },
    // eslint-disable-next-line no-unused-vars
    isAvailableWeek(week) {
      return true;
      // if (!week[0]) return false;
      //
      // const day = week[0].date;
      // return this.generateAvailableDays().some(el => dateFormat(day, 'yyyy-mm-dd') === dateFormat(el, 'yyyy-mm-dd'))
    },

    checkSpecialDay(date) {
      let specialDay = false;
      if (this.isSpecialData) {
        specialDay = this.specialData.set_meals.filter(el => isShoppingAssignmentActive(el, this.shoppingToday)).some(el => String(el.date).slice(0, 10) === dateFormat(date, 'yyyy-mm-dd'))
      }
      return specialDay;
    },

    checkSelectedDay(date) {
      if (!this.weekSelect && !this.isRangeSelect) return {};

      let from, to;
      if (this.weekSelect) {
        from = this.currentSetWeek.from;
        to = this.currentSetWeek.to;
      } else if (this.isRangeSelect) {
        from = this.currentSetRange.from;
        to = this.currentSetRange.to;
      }

      return {
        first: dateFormat(date, 'yyyy-mm-dd') === dateFormat(from, 'yyyy-mm-dd'),
        last: to && dateFormat(date, 'yyyy-mm-dd') === dateFormat(to, 'yyyy-mm-dd'),
        current: to && (
          (new Date(date)).getTime() >= (new Date(from)).getTime() &&
          (new Date(date)).getTime() <= (new Date(to)).getTime()
        ),
        noto: !to,
      }
    },

    getYearMonthes(){
      // eslint-disable-next-line no-unused-vars
      const year = 2000; // may be any
      return (new Array(12)).fill(0).map((el, index) => {
        return dateFormat(new Date(year, index), 'mmm')
      })
    },

    isWeekSelected(week) {
      if (!week || !this.currentSetWeek || !this.weekSelect || this.isRangeSelect) return false;
      return dateFormat(week[0].date, 'yyyy-mm-dd') === dateFormat(this.currentSetWeek.from, 'yyyy-mm-dd')
    },

    async showCalendar() {
      let date = new Date();
      if (!this.weekSelect && this.currentSetDate) {
        date = new Date(this.currentSetDate);
      } else if (this.weekSelect && this.currentSetWeek) {
        date = new Date(this.currentSetWeek.from)
      } else if (this.isRangeSelect && this.currentSetRange) {
        date = new Date(this.currentSetRange.from)
      }

      this.currentDate.year = date.getFullYear();
      this.currentDate.month = date.getMonth();

      this.calendar = this.generateCurrentCalendar();

      await this.$nextTick();

      this.generateAvailableDays();
      if (this.$mq === 'lg' || this.$mq === 'xl') return;

      this.$refs.swiper?.swiper.slideTo(this.currentDate.month, 0, false)
    },
    async monthSelect() {
      await this.$nextTick();
      const index = this.$refs.monthItem.map(el => Object.values(el.$el.classList)).findIndex(el => el.some(c => c ==='swiper-slide-active'));

      this.currentDate.month = index;
    },

    close() {
      this.currentClassPosition = [];
      this.selectedDate = null;
      this.selectedDate = null;
    },

    checkActiveDay(date) {
      if (!date || !this.currentSetDate || this.weekSelect || this.isRangeSelect) return false;
      return dateFormat(date, 'yyyy-mm-dd') === dateFormat(this.currentSetDate, 'yyyy-mm-dd');
    },

    selectWeek(weekIndex) {
      if (this.weekSelect) {
        this.selectedWeek = {
          from: this.calendar[weekIndex][0].date,
          to: this.calendar[weekIndex][this.calendar[weekIndex].length - 1].date,
        }
        this.$emit('week', this.selectedWeek);
      }
    },
    selectDate({ date, isEmpty }, { first, last, current, noto }) {
      if (!this.weekSelect && !isEmpty && !this.isRangeSelect) {
        this.selectedDate = date;
        console.log('Emit date')
        this.$emit('date', date);
        this.close();
      }

      if (this.isRangeSelect) {
        if (first || last) return;

        if (current || noto && new Date(this.currentSetRange.from) < new Date(date)) {
          // Смещаем конец
          this.selectedRange = {
            from: this.currentSetRange.from,
            to: date,
          }
          this.$emit('range', this.selectedRange)
        } else {
          this.selectedRange = {
            from: date,
            to: null,
          }
          this.$emit('range', this.selectedRange)
        }
      }
    },

    setToday() {
      this.$emit('date', new Date())
      this.close();
    },

    setPrevYear() {
      if (this.currentDate.year - 1 >= 1900) {
        this.currentDate.year -= 1
      }
    },
    setNextYear() {
      this.currentDate.year += 1
    },
    setYear(year) {
      this.currentDate.year = parseInt(year, 10);
      this.$refs?.yearPopper?.doClose();
    },

    setNextMonth() {
      if (this.currentDate.month + 1 <= 11) {
        this.currentDate.month += 1;
      } else {
        this.currentDate.month = 0;
        this.currentDate.year += 1;
      }
    },
    setPrevMonth() {
      if (this.currentDate.month - 1 >= 0) {
        this.currentDate.month -= 1;
      } else {
        this.currentDate.month = 11;
        this.currentDate.year -= 1;
      }
    },
    setMonth(index) {
      this.currentDate.month = index;
      this.$refs?.monthPopper?.doClose();
    },

    generateCurrentCalendar() {
      const calendar = this.createBaseCalendar();
      return this.createNeighborDates(calendar);
    },

    createBaseCalendar() {
      const d = new Date(this.currentDate.year, this.currentDate.month);

      const today = new Date();
      const currentDate = new Date(today.getFullYear(), today.getMonth(), today.getDate())

      const calendar = [];
      let row = [];
      while (d.getMonth() === this.currentDate.month) {
        row.push({ number: d.getDate(), current: currentDate.getTime() == d.getTime(), date: new Date(d) });
        if (d.getDay() === 0) {
          calendar.push(row);
          row = [];
        }
        d.setDate(d.getDate() + 1)
      }
      if (d.getMonth() !== this.currentDate.month) {
        calendar.push(row);
      }

      return calendar;
    },

    addBeforeWeek(calendar) {
      const d = new Date(this.currentDate.year, this.currentDate.month);

      const today = new Date();
      const currentDate = new Date(today.getFullYear(), today.getMonth(), today.getDate())

      let beforeWeek = new Array((d.getDay() || 7) - 1).fill(0)
      beforeWeek = beforeWeek
        .map(() => {
          const dd = d.setDate(d.getDate() - 1)
          return { isEmpty: true, number: this.getDayNumber(dd), date: dd, current: currentDate.getTime() == new Date(dd).getTime() }
        })
        .reverse()

      calendar[0] = beforeWeek.concat(calendar[0])
    },

    addAfterWeek(calendar) {
      const d = new Date(this.currentDate.year, this.currentDate.month + 1); // Следующий месяц
      const last_day = new Date(d.setDate(d.getDate() - 1));
      const last_day_index = last_day.getDay();

      const today = new Date();
      const currentDate = new Date(today.getFullYear(), today.getMonth(), today.getDate())

      let afterWeek = new Array(7 - (last_day_index || 7)).fill(0)
      afterWeek = afterWeek
        .map(() => {
          const dd = last_day.setDate(last_day.getDate() + 1);
          return { isEmpty: true, number: this.getDayNumber(dd), date: dd, current: currentDate.getTime() == new Date(dd).getTime() }
        })

      calendar[calendar.length - 1] = calendar[calendar.length - 1].concat(afterWeek);
    },

    createNeighborDates(calendar) {
      this.addBeforeWeek(calendar);
      this.addAfterWeek(calendar);
      return calendar;
    },

    getDayNumber(date) {
      return (new Date(date)).getDate();
    }
  }
}
</script>


<style lang="scss">
.k-modal-popper {
  background: #FFFFFF;
  box-shadow: 0px -4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  padding: 10px 20px;
  text-align: center;
  z-index: 10;

  .popper__arrow {
    display: none;
  }
}
.swiper-wrapper {
  display: flex !important
}
</style>

<style lang="scss" scoped>

.k-calendar {
  border-radius: 2px;
  width: 350px;
  min-height: 325px;
  cursor: default;
  user-select: none;
  p {
    margin: 0;
  }
}

.k-calendar-day-wrapper {
  width: 100%;
  &.selected {
    background: rgba(230, 144, 61, 0.4);
  }
  &.first {
    background: rgba(230, 144, 61, 0.4);
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
  }
  &.last {
    background: unset;
  }
}
.k-calendar__header {
  display: flex !important;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;

  p:not(.k-calendar__button-today) {
    font-weight: normal;
    font-size: 16px;
    color: #616161;
    cursor: pointer;
  }

  &.mobile {
    justify-content: center;
    margin: 10px 0;
    p {
      font-size: 18px;
      color: #F68C1E;
      font-weight: 600;
    }
    .k-calendar-picker {
      width: 200px;
      font-size: 18px;
    }
    .k-calendar-picker__item {
      height: 40px;
    }
  }
}

.k-calendar .k-calendar-row {
  display: flex !important;
  align-items: center;
}

.k-calendar-arrow {
  cursor: pointer;
}

.k-calendar__button-today {
  color: #F7981E;
  font-size: 12px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.k-calendar__body {

}

.k-calendar-days {
  justify-content: space-between;
  padding: 0 25px;
}
.k-calendar-day {
  color: #616161;
  font-size: 12px;
  width: 25px;
  height: 25px;
  line-height: 1;
  display: flex !important;
  justify-content: center;
  align-items: center;

  &.inactive.test {
    pointer-events: none;
  }
  &.inactive:not(.first):not(.last) {
    color: #616161;
    opacity: 0.4;
    cursor: default !important;
  }
  &.current {
    color: #F68C1E;
    position: relative;
  }
  &.special {
    border: 1px solid rgba(230, 144, 61, 0.4);
    border-radius: 50%;
  }
  &.active {
    position: relative;
    color: #fff;
    background: #F7981E;
    border-radius: 50%;
  }
  &.last,
  &.first {
    position: relative;
    color: #fff;
    background: #F7981E;
    border-radius: 50%;
  }
  &.last {
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(230, 144, 61, 0.4);
      border-top-right-radius: 12px;
      border-bottom-right-radius: 12px;
    }
  }
}
.k-calendar-divider {
  border: 1px solid #F7981E;
  width: 100%;
}
.k-calendar-week {
  margin-bottom: 15px;

  &.selected > div {
    background: rgba(230, 144, 61, 0.4);
    border-radius: 12px;
  }
  &.selected {
    .k-calendar-day:last-child,
    .k-calendar-day:first-child {
      position: relative;
      color: #fff;
      background: #F7981E;
      border-radius: 50%;
    }
  }
  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}

.k-calendar-week .k-calendar-day {
  cursor: pointer;

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}

.k-calendar-description {
  font-size: 14px;
  color: #000000;
  opacity: 0.64;
  text-align: left;
}

.k-calendar-month-date {
  width: 75px;
}
.k-calendar-mobile {
  display: none !important;
}
.k-calendar__hide-button {
  cursor: pointer;
}

.k-calendar-picker {
  width: 150px;
  color: #616161;
  user-select: none;
}
.k-calendar-picker__item {
  display: flex !important;
  justify-content: center;
  align-items: center;
  height: 24px;
  cursor: pointer;
  border-radius: 4px;
  transition: background .2s linear;
  &:hover {
    background: #f1f1f1;
  }
}

@media (max-width: 767.98px) {
  .k-calendar-days {
    padding: 0;
  }
  .k-calendar__wrapper {
    background: rgba(0, 0, 0, 0.2);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10;

    &--left,
    &--right  {
      transform: unset;
    }
  }
  .k-calendar {
    border-radius: none;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    width: 100%;
    min-height: 400px;
    &.autobox {
      min-height: unset;
    }
  }
  .k-calendar-mobile {
    display: block !important;
  }
  .k-calendar-desktop {
    display: none !important;
  }
  .k-calendar-month-item {
    font-size: 16px;
    color: #F68C1E;
    &:not(.swiper-slide-active) {
      opacity: 0.5;
    }
  }
  .k-calendar-description {
    display: block !important;
  }
}

.k-calendar__switcher {
  display: flex;
  justify-content: space-between;

  span {
    font-size: 13px;
    text-align: center;
    cursor: pointer;
    padding: 3px 10px;
    border-radius: 6px;
    width: 40%;
    max-width: 135px;
    color: #000000;
    text-align: center;
    opacity: 0.64;
    border: 1px solid #000000;
  }
  span.active {
    background: #F68C1E;
    color: #fff;
    opacity: 1;
    border: none;
  }
}
</style>
